import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { labelText } from "@cloudpivot/form/src/schema/system-data-item-codes";
import HLabel from "@cloudpivot/form/src/common/components/label.vue";
let CreatedDeptId = class CreatedDeptId extends Vue {
    render(h) {
        return h('h-label', { props: { text: labelText
            } });
    }
};
tslib_1.__decorate([
    Prop()
], CreatedDeptId.prototype, "control", void 0);
CreatedDeptId = tslib_1.__decorate([
    Component({
        name: 'CreatedDeptId',
        components: {
            HLabel: HLabel
        }
    })
], CreatedDeptId);
export default CreatedDeptId;
